import {TrafficShapingStatus} from "../Models/TrafficShapingStatus";
import HttpService from "./HttpService";
import AddGroupToTrafficShaping from "../Requests/TrafficShaping/AddGroupToTrafficShaping"
import {TrafficShapingSettings} from "../Models/TrafficShapingSettings";
import Cube from "../Models/Cube";
import Group from "../Models/Group";

export class QueueLineService
{
    public static checkIn(cube: Cube, group: Group): Promise<void>
    {
        if (group.groupIdentifiers.length == 0)
        {
            return Promise.reject("Group has no identifiers");
        }
        
        const url = '/QueueLine';
        const request = {
            cubeId: cube.id,
            groupIdentifier: group.groupIdentifiers[0].identifier,
        }
        return HttpService.post<void>(url, request);
    }
}